import React, { useCallback } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { TempoSwitch } from '../../../styles/customTheme/customStyledSwitch';

interface Props {
  name: string;
  isRequired?: boolean;
  switchType?: 'normal' | 'tempoSwitch';
  defaultValue?: boolean;
}

const style = {
  formControl: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-around',
  },
} as const;

export function AppControlledSwitch({
  name,
  isRequired = false,
  switchType = 'tempoSwitch',
  defaultValue = true,
}: Props): JSX.Element {
  const { control } = useFormContext();

  const formControl = useCallback(({ onChange, value }) => {
    if (switchType === 'tempoSwitch') {
      return (
        <TempoSwitch
          onChange={(event) => {
            onChange(event.target.checked);
          }}
          checked={value}
          color="default"
        />
      );
    }

    return (
      <Switch
        onChange={(event) => {
          onChange(event.target.checked);
        }}
        checked={value}
        color="default"
      />
    );
  }, []);

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      rules={{ required: isRequired }}
      render={({ field: { onChange, value } }) => {
        return (
          <FormControlLabel
            control={formControl({ onChange, value })}
            label={null}
            labelPlacement={'start'}
            sx={style.formControl}
          />
        );
      }}
    />
  );
}
